<label class="fw-bold py-2">{{ label }}</label>
@if (getInitialValue()) {
  <editor
    [init]="editorConfig"
    [initialValue]="getInitialValue()"
    [licenseKey]="'gpl'"
    (onInit)="contentFormControl.setValue(getInitialValue())"
    >
  </editor>
}
